import {Component, signal} from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {ICellRendererParams} from 'ag-grid-community';
@Component({
  selector: 'em-external-link-renderer',
  imports: [],
  templateUrl: './external-link-renderer.component.html',
  styleUrls: ['./external-link-renderer.component.scss'],
  styles: [],
})
export class ExternalLinkRendererComponent implements ICellRendererAngularComp {
  value = signal<{url: string; text: string}>({url: '', text: ''});

  // gets called once before the renderer is used
  agInit(params: ICellRendererParams): void {
    this.refresh(params);
  }

  // gets called whenever the cell refreshes
  refresh(params: ICellRendererParams): boolean {
    // set value into cell again
    this.value.set({url: params.value.url, text: params.value.text});
    return true;
  }
}
